import {Route, Routes, useLocation, useNavigate} from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/style/main.scss";
import Dashboard from "./pages/Dashboard";
import Header from "./sharedComponents/Header";
import Sidebar from "./sharedComponents/Sidebar";
import Login from "./pages/Login";
import Admin from "./pages/Admin";
import Users from "./pages/Users";
import Orders from "./pages/Orders";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Products from "./pages/Products";
import TermsAndConditions from "./pages/TermsAndConditions";
import VendingMachine from "./pages/VendingMachine";
import Categories from "./pages/Categories";
import ContactUs from "./pages/ContactUs";
import QueryManagement from "./pages/QueryManagement";
import AboutUs from "./pages/AboutUs";
import TransactionLog from "./pages/TransactionLog";
import StockStatement from "./pages/StockStatement";
import {useContext, useEffect, useState} from "react";
import {ToastContainer} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentFailed from "./pages/PaymentFailed";
import AboutUsDescp from "./pages/AboutUsDescp";
import PrivacyPolicyDescp from "./pages/PrivacyPolicyDescp";
import TermsDescp from "./pages/TermsDescp";
import AgeVerification from "./sharedComponents/webSdk/AgeVerification";
import Success from "./sharedComponents/webSdk/Success";
import Faild from "./sharedComponents/webSdk/Faild";
import {AppContext} from "./context/AppContext";
import ScanFaild from "./sharedComponents/webSdk/ScanFaild";
import ProductList from "./pages/ProductList";
// import "react-select-search/style.css";
import InventoryLog from "./pages/InventoryLog";
import CouponCode from "./pages/CouponCode";
import MachineOrders from "./pages/MachineOrders";
import ProductReview from "./pages/ProductReview";
import ProductReviews from "./pages/ProductReviews";

function App() {
    const location = useLocation();
    let currentRoute = location.pathname;
    console.log("currentRoute", currentRoute);
    const [logedIn, setLoggedIn] = useState(localStorage.getItem("logedIn") ? localStorage.getItem("logedIn") : false);
    const navigate = useNavigate();
    const {LinkproductId, LinkVendingmachineid, Linkslotno, Linkdevicetoken, LinkOrderId} = useContext(AppContext);

    // useEffect(() => {
    //   if (!logedIn) {
    //     navigate("/");
    //   } else navigate("dashboard");
    // }, [logedIn]);
    useEffect(() => {
        if (!logedIn) {
            if (currentRoute.includes("PaymentSuccess") || // currentRoute.includes("PaymentSuccess/:orderid") ||
                currentRoute.includes("PaymentFailed") || currentRoute.includes("About-us") || currentRoute.includes("Privacy-details") || currentRoute.includes("Terms-descp") || currentRoute.includes('AgeVerification') || currentRoute.includes('AgeVerification/:productid/:vendingmachineid/:slotno/:devicetoken') || currentRoute.includes('Failed') || currentRoute.includes('ScanFaild') || currentRoute.includes('Success')) {
                navigate(currentRoute);
            } else navigate("/");
        } else {
            if (currentRoute !== "/") {
                navigate(currentRoute);
            } else navigate("/Dashboard");
        }
    }, [logedIn]);


    console.log("link testing", `/AgeVerification/${LinkproductId}/${LinkVendingmachineid}/${Linkslotno}/${LinkOrderId}`);
    let urlData = location.pathname?.split("/")
    console.log(urlData)
    const orderLinkID = urlData[2]
    console.log("link PaymentSuccess", `/PaymentSuccess/${orderLinkID}`);
    const routes = [

        "/PaymentSuccess",

        // { path: "/", name: "login", Component: Login },

        // { path: "/LoginWithOTP", name: "loginwithotp", Component: LoginWithOTP },

    ];
    return (<>
        <ToastContainer/>
        <div className="App">
            {currentRoute !== "/" && (<>
                {!(currentRoute === `/PaymentSuccess/${orderLinkID}` || currentRoute === "/PaymentSuccess" || currentRoute === "/PaymentFailed" || currentRoute === "/About-us" || currentRoute === "/AgeVerification/:productid/:vendingmachineid/:slotno/:orderid" || currentRoute === "/Privacy-details" || currentRoute === "/Terms-descp" || currentRoute === "/AgeVerification" || currentRoute === "/Failed" || currentRoute === "/ScanFaild" || currentRoute === "/Success") ? (<>
                    {currentRoute == `/AgeVerification/${LinkproductId}/${LinkVendingmachineid}/${Linkslotno}/${LinkOrderId}` || currentRoute == `/paymentSuccess/${orderLinkID}` ? <>

                    </> : <>
                        <Header setLoggedIn={setLoggedIn}/>
                        <Sidebar/>
                    </>

                    }

                </>) : (<></>)}
            </>)}
            <Routes>
                <Route path="/" element={<Login setLoggedIn={setLoggedIn}/>}/>

                <Route path="Dashboard" element={<Dashboard/>}/>
                <Route path="Admin" element={<Admin/>}/>
                <Route path="Users" element={<Users/>}/>
                <Route path="Orders" element={<Orders/>}/>
                <Route path="PrivacyPolicy" element={<PrivacyPolicy/>}/>
                <Route path="Products" element={<Products/>}/>
                <Route path="ProductReviews" element={<ProductReviews/>}/>
                {/* <Route path="QRCodeManagement" element={<QRCodeManagement />} /> */}
                {/* <Route path="TransactionHistory" element={<TransactionHistory />} /> */}
                <Route path="TermsAndConditions" element={<TermsAndConditions/>}/>
                <Route path="VendingMachine" element={<VendingMachine/>}/>
                <Route path="Categories" element={<Categories/>}/>
                <Route path="CouponCodes" element={<CouponCode/>}/>
                <Route path="AboutUs" element={<AboutUs/>}/>
                <Route path="ContactUs" element={<ContactUs/>}/>
                <Route path="QueryManagement" element={<QueryManagement/>}/>

                <Route path="TransactionLog" element={<TransactionLog/>}/>
                <Route path="StockStatement" element={<StockStatement/>}/>
                {/* <Route path="PaymentSuccess" element={<PaymentSuccess />} /> */}
                <Route path="PaymentSuccess/:orderid" element={<PaymentSuccess/>}/>
                <Route path="PaymentFailed" element={<PaymentFailed/>}/>
                <Route path="AgeVerification" element={<AgeVerification/>}/>

                <Route path="AgeVerification/:productid/:vendingmachineid/:slotno/:orderid"
                       element={<AgeVerification/>}/>

                <Route path="Success" element={<Success/>}/>
                <Route path="Failed" element={<Faild/>}/>
                <Route path="ScanFaild" element={<ScanFaild/>}/>

                {/* Description pages */}
                <Route path="About-us" element={<AboutUsDescp/>}/>
                <Route path="Privacy-details" element={<PrivacyPolicyDescp/>}/>
                <Route path="Terms-descp" element={<TermsDescp/>}/>
                <Route path="/ProductList/:id" element={<ProductList/>}/>
                <Route path="Products/:id/Reviews" element={<ProductReview/>}/>
                <Route path="/MachineOrders/:id" element={<MachineOrders/>}/>
                <Route path="/InventoryLog" element={<InventoryLog/>}/>
            </Routes>
        </div>
    </>);
}

export default App;
